/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { jsx, css } from '@emotion/react'
import { useField } from 'formik'
import { map } from 'lodash'
import { default_theme as theme } from '../../emotion/theme'
import FormError from './FormError'
import FormWarning from './FormWarning'
import Form from 'react-bootstrap/Form'
import { LanguageFlag } from '../LanguageFlag'
import { FormikTextarea } from './TextareaField'
import { LANGUAGES } from '../../actions/language'

export const MultilingualField = ({ name, label, render_component, ...props }) => {

    return (

        <div>
          { map(LANGUAGES, ({language_code, language_name}, index) => {
              return (
                  <div key={index}>
                    {label} <LanguageFlag language_code={language_code} label={language_name} />
                    { render_component( {name:`${name}_${language_code}`} ) }
                  </div>
              )
          })}
        </div>
        
    )
}
